import { render, staticRenderFns } from "./AddDeliveryRoutePage.vue?vue&type=template&id=25cbcaa6"
import script from "./AddDeliveryRoutePage.vue?vue&type=script&lang=js"
export * from "./AddDeliveryRoutePage.vue?vue&type=script&lang=js"
import style0 from "./AddDeliveryRoutePage.vue?vue&type=style&index=0&id=25cbcaa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports